import { articles, channels, type Article, type Channel } from "@/mocks/chigua";

export function getChannel(slug: string): Channel | undefined {
  return channels.find((c) => c.slug === slug);
}

export function getArticle(slug: string): Article | undefined {
  return articles.find((a) => a.slug === slug);
}

export function channelArticles(slug: string): Article[] {
  return articles.filter((a) => a.channel === slug);
}

export function getArticlesBySlugs(slugs: string[]): Article[] {
  return slugs
    .map((s) => getArticle(s))
    .filter((a): a is Article => Boolean(a));
}

export const topHot: Article[] = [...articles]
  .sort((a, b) => b.heat - a.heat)
  .slice(0, 5);

export const featuredDeep: Article[] = articles.filter((a) => a.featured);
export const deepArticles: Article[] = channelArticles("shenba");

export interface ToneClass {
  text: string;
  bg: string;
  softBg: string;
  border: string;
  dot: string;
  chipBg: string;
  chipText: string;
}

export function toneOf(channelSlug: string): ToneClass {
  const c = getChannel(channelSlug);
  const t = c?.tone ?? "primary";
  if (t === "accent") {
    return {
      text: "text-accent-600",
      bg: "bg-accent-500",
      softBg: "bg-accent-100/70",
      border: "border-accent-300",
      dot: "bg-accent-500",
      chipBg: "bg-accent-100",
      chipText: "text-accent-800",
    };
  }
  if (t === "secondary") {
    return {
      text: "text-secondary-700",
      bg: "bg-secondary-600",
      softBg: "bg-secondary-100/70",
      border: "border-secondary-300",
      dot: "bg-secondary-500",
      chipBg: "bg-secondary-100",
      chipText: "text-secondary-900",
    };
  }
  return {
    text: "text-primary-600",
    bg: "bg-primary-500",
    softBg: "bg-primary-100/70",
    border: "border-primary-300",
    dot: "bg-primary-500",
    chipBg: "bg-primary-100",
    chipText: "text-primary-800",
  };
}

export function kindBadge(kind: string): string {
  switch (kind) {
    case "深扒":
      return "bg-accent-500 text-background-50";
    case "复盘":
      return "bg-secondary-500 text-background-50";
    case "速递":
      return "bg-primary-500 text-background-50";
    default:
      return "bg-background-200 text-foreground-800";
  }
}

export function formatHeat(n: number): string {
  if (n >= 10000) return `${(n / 10000).toFixed(1)}w`;
  return `${n}`;
}